export const BRAND = {
  name: "Marine & Recreational Hauling",
  short: "M&R Hauling",
  tagline: "Direct Carrier. Not a Broker.",
  phone: "+14033543434",
  email: "myshipservices@gmail.com",
  hours: "Mon–Sat · 7:00 – 20:00 ET",
};

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/198c806a-40b0-4047-b83f-e4865cd7a905/images/84d78beca6baeed6950360fee2a1e39e868d2da3e72df1b3ce147e5fba14a4d5.png",
  rv: "https://static.prod-images.emergentagent.com/jobs/198c806a-40b0-4047-b83f-e4865cd7a905/images/84d78beca6baeed6950360fee2a1e39e868d2da3e72df1b3ce147e5fba14a4d5.png",
  atv: "https://static.prod-images.emergentagent.com/jobs/198c806a-40b0-4047-b83f-e4865cd7a905/images/7bd4538965d2f761f333b4c011165aa6aa1fd14c00656913eace4310975c0b13.png",
  boat: "https://static.prod-images.emergentagent.com/jobs/198c806a-40b0-4047-b83f-e4865cd7a905/images/34b46c393bb4fd335542bc18c35e490ecce1b4c03d83015364f98fd594d939d0.png",
  snowmobile: "https://images.pexels.com/photos/12138608/pexels-photo-12138608.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  motorcycle: "https://images.pexels.com/photos/33397827/pexels-photo-33397827.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  landscape: "https://static.prod-images.emergentagent.com/jobs/198c806a-40b0-4047-b83f-e4865cd7a905/images/10e8e4f97b0a41f30c6a02b8f38ac82dfb92e464ed86c6b4dac9c41c6b3b98ac.png",
};

export const SERVICES = [
  {
    key: "rv",
    title: "RV & Motorhome",
    blurb: "Motorhomes, travel trailers, fifth wheels, pop-ups and truck campers. Fully strapped and inspected at every stop.",
    image: IMAGES.rv,
    alt: "Heavy-duty semi-truck hauling a Class A motorhome through the Canadian Rockies — RV transport service",
    features: ["Motorhomes", "Travel trailers", "Fifth wheels", "Pop-ups & truck campers"],
  },
  {
    key: "motorcycle",
    title: "Motorcycle",
    blurb: "Cruisers, sport, touring, ADV, trikes — enclosed and soft-strapped by riders who ride.",
    image: IMAGES.motorcycle,
    alt: "Row of motorcycles loaded for enclosed transport — Canadian motorcycle shipping service",
    features: ["Enclosed transport", "Soft-tie & chock system", "Vintage & custom builds", "Showroom delivery"],
  },
  {
    key: "atv",
    title: "ATV & Side-by-Side",
    blurb: "Quads, UTVs, side-by-sides — farm-run or fresh off the dealer floor.",
    image: IMAGES.atv,
    alt: "Polaris ATV side-by-side ready for hauling — Canadian ATV and UTV transport",
    features: ["Quads & UTVs", "Side-by-sides", "Dealer-to-dealer", "Rural & remote pickups"],
  },
  {
    key: "snowmobile",
    title: "Snowmobile",
    blurb: "Winter-ready carriers. Sleds secured, covered, and moved coast-to-coast.",
    image: IMAGES.snowmobile,
    alt: "Snowmobile being prepared for winter transport — Canadian sled hauling service",
    features: ["Trail & mountain sleds", "Multi-sled loads", "Seasonal routing", "Heated-storage stops"],
  },
  {
    key: "marine",
    title: "Marine & Boats",
    blurb: "Bowriders, pontoons, jet skis, fishing rigs — trailered with marine-grade tie-downs.",
    image: IMAGES.boat,
    alt: "Boat being loaded onto a marine trailer for cross-Canada transport — boat hauling service",
    features: ["Bowriders & pontoons", "Jet skis / PWC", "Fishing & bass boats", "Launch / marina delivery"],
  },
];

export const PROVINCES = [
  "AB", "BC", "MB", "NB", "NL", "NS", "ON", "PE", "QC", "SK", "YT",
];
